<template>
  <div class="d-flex align-items-center flex-wrap mt-1 gap-3">
    <b v-if="pppActiveSessions?.length > 0">
      Current dBm
      <span
        v-if="pppActiveSessions[0] && pppActiveSessions[0].Uptime"
        class="badge mx-1 bg-dark text-white"
      >
        <span
          class="inline-block bg-success rounded-circle"
          style="
            height: 0.5rem;
            width: 0.5rem;
            display: inline-block;
            margin-right: 0.25rem;
          "
        ></span>
        Online
      </span>
      <span v-else class="badge mx-1 bg-dark text-white">
        <span
          class="inline-block bg-danger rounded-circle"
          style="
            height: 0.5rem;
            width: 0.5rem;
            display: inline-block;
            margin-right: 0.25rem;
          "
        ></span>
        Offline
      </span>
    </b>
    <b>
      <span
        class="badge mx-1 bg-dark text-danger cursor-pointer"
        @click="$emit('refresh')"
      >
        Refresh
        <span
          v-if="refreshLoader"
          class="spinner-border spinner-border-sm mx-3"
        ></span>
        <span v-else>
          <i
            class="fas fa-sync-alt ml-1 mb-1"
            style="font-size: 10px; color: red"
          ></i>
        </span>
      </span>
    </b>
    <b v-if="sharePortData.port_type">
      <span>
        <div>
          <div class="d-flex justify-content-between">
            <p class="mb-0 text-xs font-weight-bold">
              <b class="text-sm"> {{ sharePortData?.port_number_name }} </b>
            </p>
            <p class="mb-0 text-xs font-weight-bold">
              <b class="text-sm mx-3"
                >{{ sharePortData?.running_connection_port }}/{{
                  sharePortData?.port_type == "GPON" ? 128 : 64
                }}</b
              >
            </p>
          </div>
          <div class="progress w-100">
            <div
              class="progress-bar"
              :class="
                sharePortData?.port_type == 'GPON'
                  ? progressBarClass(sharePortData?.running_connection_port)
                  : progressBarClassEpon(
                      sharePortData?.running_connection_port
                    )
              "
              role="progressbar"
              :style="{
                width: `${Math.min(
                  (sharePortData?.running_connection_port /
                    (sharePortData?.port_type == 'GPON' ? 128 : 64)) *
                    100,
                  100
                )}%`,
              }"
              :aria-valuenow="sharePortData?.running_connection_port"
              aria-valuemin="0"
              :aria-valuemax="sharePortData?.port_type == 'GPON' ? 128 : 64"
            ></div>
          </div>
        </div>
      </span>
    </b>

    <i
      @click="$emit('set-edit')"
      class="fas fa-edit cursor-pointer"
      style="color: gray; font-size: 14px"
    ></i>
    <i
      @click="$emit('delete-popup', id)"
      class="fas fa-trash-alt cursor-pointer"
      style="color: gray; font-size: 12px"
    ></i>
  </div>
</template>

<script>
export default {
  name: "GraphHeader",
  props: {
    pppActiveSessions: {
      type: Array,
      default: () => [],
    },
    refreshLoader: {
      type: Boolean,
      default: false,
    },
    sharePortData: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    progressBarClass(port_count) {
      if (port_count >= 120) {
        return "bg-danger"; // red
      } else if (port_count >= 100) {
        return "bg-warning"; // medium
      } else {
        return "bg-success"; // normal
      }
    },
    progressBarClassEpon(port_count) {
      if (port_count >= 60) {
        return "bg-danger"; // red
      } else if (port_count >= 50) {
        return "bg-warning"; // medium
      } else {
        return "bg-success"; // normal
      }
    },
  },
};
</script>

